import React from 'react'
import { AnnouncementData } from "../../redux/auth-reducer/auth-service";
import { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { formatUsd } from '../../utils/helper/money';

// The server sends isBuyback as true/false to the Web Admin and the auction's manager team, and as
// null to everyone else - Players included - so its presence alone decides whether the column shows.
const hasBuybackMark = (row) => row?.isBuyback === true || row?.isBuyback === false;

const unsavedLabel = (count) =>
  count === 0 ? "All changes saved" : count === 1 ? "1 unsaved change" : `${count} unsaved changes`;

/**
 * The expanded panel of one auction on Auction Results: its teams, with the Team Buyback marks
 * (MG-003.1) when the caller may change them, and its contest winners.
 *
 * @param {{ data: object, buyback?: ReturnType<typeof import('./useBuybackDrafts').useBuybackDrafts> }} props
 *   data is the auction row. buyback is the page's draft state, which outlives this component - it
 *   unmounts whenever a search hides its row or the pager moves past it.
 */
export const AuctionResultDetails = ({ data, buyback }) => {
  const [announcements, setAnnouncements] = useState([]);
  const auctionId = data.auctionId;
  const load = buyback?.load;



  useEffect(() => {
    const AnnouncementDataFunc = async () => {
      await AnnouncementData(auctionId).then((response) => {
        setAnnouncements(response?.data);

        const rows = response?.data?.announcementData ?? [];
        if (load && rows.some(hasBuybackMark)) load(auctionId, rows);
      });
    };
    AnnouncementDataFunc();
  }, [auctionId, load]);



  const teams = announcements?.announcementData ?? [];
  const showBuyback = !!buyback && teams.some(hasBuybackMark);
  const entry = buyback?.entries?.[auctionId];
  const changes = entry?.changes ?? {};
  const changedCount = Object.keys(changes).length;
  const saving = !!entry?.saving;

  const isChecked = (item) =>
    item.teamId in changes ? changes[item.teamId] : entry ? !!entry.saved[item.teamId] : !!item.isBuyback;

  const handleSave = async () => {
    if (await buyback.save(auctionId)) toast.success("Changes saved");
  };

  return (
    <div className='innerdiv'>

      <div style={{ color: "#fff", backgroundColor: "blue" }} >

      </div>

      <div className='p-3'>

        {showBuyback && (
          <div className="buyback-bar">
            <div className={changedCount ? "buyback-status is-dirty" : "buyback-status"} role="status">
              {changedCount > 0 && <span className="buyback-dot" aria-hidden="true" />}
              {unsavedLabel(changedCount)}
            </div>
            {changedCount > 0 && (
              <div className="buyback-actions">
                <button
                  type="button"
                  className="buyback-btn buyback-btn-outline"
                  onClick={() => buyback.discard(auctionId)}
                  disabled={saving}
                >
                  Discard changes
                </button>
                <button type="button" className="buyback-btn buyback-btn-primary" onClick={handleSave} disabled={saving}>
                  {saving ? "Saving..." : "Save changes"}
                </button>
              </div>
            )}
          </div>
        )}

        {showBuyback && entry?.error && (
          <div role="alert" className="buyback-error">
            {entry.error}
          </div>
        )}

        <Table striped bordered hover size="sm" className={showBuyback ? 'text-center buyback-table' : 'text-center'}>
          <thead>
            <tr>

              {showBuyback && <th scope="col" className="buyback-col">Team Buyback</th>}
              <th>Team Name</th>
              <th>Winning Bidder</th>
              <th >Bid Amount</th>
            </tr>
          </thead>
          <tbody>
            {
              // One row per team: since #125 usp_GetAnnouncementById picks a single top bid per lot
              // (it used to list a team once per tied top bid), so the team id is a safe key - and it
              // is what the Team Buyback draft is keyed by too.
              teams.map((item) => {
                const changed = showBuyback && item.teamId in changes;
                return (
                  <tr key={item?.teamId} className={changed ? "buyback-unsaved" : undefined}>
                    {showBuyback && (
                      <td className="buyback-col">
                        <label className="buyback-check">
                          <input
                            type="checkbox"
                            checked={isChecked(item)}
                            onChange={() => buyback.toggle(auctionId, item.teamId)}
                            disabled={saving}
                            aria-label={`Team Buyback for ${item?.teamName}`}
                          />
                        </label>
                      </td>
                    )}
                    <td>
                      {item?.teamName}
                      {changed && <span className="buyback-pill">Unsaved</span>}
                    </td>
                    <td>{item?.playerName == null ? "-" : item?.playerName}</td>
                    <td className='text-payout'>{formatUsd(item?.maxAmount)}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>

        <div>
          <span style={{ fontWeight: "600" }}>Contest Winner Details </span>
          <br />
          <br />

          {/* #298: no Position column. The rows already come in finishing order
              (usp_GetAnnouncementById), so the order says it. */}
          <Table striped bordered hover size="sm" className='text-center'>
            <thead>
              <tr>
                <th>Winning Team</th>
                <th>Winner %</th>
                <th>Winner Amount</th>

              </tr>
            </thead>
            <tbody>
              {

                announcements?.winnerData?.map((item, i) => (
                  <tr key={`${item?.winnerTeamId}-${i}`}>

                    <td className='text-payout'>{item.winnerTeamName == "" ? "To be declared" : item?.winnerTeamName}</td>
                    <td>{item?.winnerPercentage}</td>
                    <td>{formatUsd(item?.winnerAmount)}</td>
                  </tr>
                ))

              }

            </tbody>
          </Table>

        </div>

      </div>
    </div>
  )
}
